import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUserProfile, getUserActivity, getSubscriptions } from '@/api/user.api';

export const fetchUserProfile = createAsyncThunk(
    'user/fetchProfile',
    async (_, { rejectWithValue }) => {
        const res = await getUserProfile();
        if (res?.code === 200) return res.data;
        return rejectWithValue('Failed to fetch profile');
    }
);

export const fetchUserActivity = createAsyncThunk(
    'user/fetchActivity',
    async ({ to, from, source }, { rejectWithValue }) => {
        const res = await getUserActivity(to, from, source);
        if (res?.code === 200) return res.data;
        return rejectWithValue('Failed to fetch activity');
    }
);

export const fetchSubscriptions = createAsyncThunk(
    'user/fetchSubscriptions',
    async (_, { rejectWithValue }) => {
        const res = await getSubscriptions();
        if (res?.code === 200) return res.data?.payments ?? [];
        return rejectWithValue('Failed to fetch subscriptions');
    }
);


const userSlice = createSlice({
    name: 'user',
    initialState: {
        profile: null,
        subscriptions: [],
        activity: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserProfile.pending, (state) => { state.loading = true; })
            .addCase(fetchUserProfile.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.profile = payload;
            })
            .addCase(fetchUserProfile.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
            })

            .addCase(fetchSubscriptions.fulfilled, (state, { payload }) => {
                state.subscriptions = payload;
            })

            .addCase(fetchUserActivity.fulfilled, (state, { payload }) => {
                state.activity = payload;
            });
    },
});

export default userSlice.reducer;